var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeicarAbstractVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 92,
    viewBox: "0 0 154 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4803 33.9912C78.2136 17.644 62.7721 5.86615 44.6194 6.12321C22.5937 6.43459 4.77768 24.7151 5.0021 46.7466C5.2229 68.7673 23.1367 86.5518 45.2058 86.5518C54.9753 86.5518 64.2453 83.4235 70.8983 77.2685C88.6817 60.8236 138.499 7.86111 138.499 7.86111C142.329 3.92911 149 6.64096 149 12.1334V88",
    stroke: "url(#paint0_linear_407_16)",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_16",
    x1: 5,
    y1: 47.3905,
    x2: 149,
    y2: 47.3905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B8DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeicarAbstractVector);
export default __webpack_public_path__ + "static/media/peicar-abstract-vector.dbc6297fe4c3f0663ad540d8b5dffb5d.svg";
export { ForwardRef as ReactComponent };